export default __webpack_public_path__ + "images/MZ.f9f28e6.png";